"use strict";
function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
// generated during pack
__export(require("./src/relayclient/GSNConfigurator"));
//# sourceMappingURL=GSNConfigurator.js.map